import Button from '@mui/material/Button';
import { useArchiveUnarchiveObjective } from './ObjectiveDetailActionHooks';
import './ObjectiveDetailAction.scss';

const UnarchiveObjectiveAction = ({
  objective,
  rowIndex,
  onSaveSuccess,
} = {
  onSaveSuccess: () => { },
}) => {
  const {
    archivedObjective,
  } = useArchiveUnarchiveObjective(objective, rowIndex, onSaveSuccess);

  return (
    <Button
      className='objective-detail-action'
      variant='contained'
      color='primary'
      onClick={() => { archivedObjective(false); }}
      tabIndex={0}
    >
      Unarchive
      <br />
      Goal/Obj
    </Button>
  );
};

export default UnarchiveObjectiveAction;
